/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Controllers.Email = class Email {
  constructor(el) {
    this._postSuccessful = this._postSuccessful.bind(this);
    this._postFailed = this._postFailed.bind(this);
    this.el = el;
    this.view = new Buyapowa.Views.Email(this.el, this);
    this.view.allowSubmit(false);
  }

  formSubmitted() {
    const opts = {
      method: "post",
      url: this.view.getUrl(),
      data: this.view.getData()
    };

    return $.ajax(opts).
      done(this._postSuccessful).
      fail(this._postFailed);
  }

  emailsChanged(count) {
    return this.view.allowSubmit(count > 0);
  }

  validateEmail(email) {
    return new Buyapowa.Helpers.EmailValidator(email).isValid();
  }

  _postSuccessful() {
    this.view.displayResult(true, this.view.emailSentText());
    return this.view.clearRecipients();
  }

  _postFailed() {
    return this.view.displayResult(false, this.view.sendErrorText());
  }
};
